export class KnownError extends Error {
  public showLogOut = false;
}
